import React, { Fragment, useState, useEffect } from 'react'
import { Form, Input, Button, Space, Skeleton, Select, Row, Col, Radio } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { postData } from '../../../Actions/Action'
import types from '../../../Stores/types'

function ConnectionSettingsComponent(props) {
	const [testType, setTestType] = useState(false)
	const [apiVersionOverride, setApiVersion] = useState(null)
	const [requiresDimensions, setRequiresDimensions] = useState(0)
	const dispatch = useDispatch()
	const { connectionSettings, token, carrierId, connectionType } = useSelector(state => state)
	const apiVersion = apiVersionOverride ?? connectionSettings?.api_version ?? 'rest'

	const handleTypeChange = type => setTestType(type)

	useEffect(() => {
		if (connectionSettings) {
			const savedApiVersion = connectionSettings?.api_version || 'rest'

			// Only dispatch dayRossApiType for legacy SOAP API
			if (savedApiVersion === 'soap') {
				const validApiTypes = ['general_freight', 'sameday']
				const apiType = validApiTypes.includes(connectionSettings?.api_type)
					? connectionSettings.api_type
					: 'general_freight'

				dispatch({
					type: types.SET_DAYROSS_API_TYPE,
					payload: apiType,
				})
			} else {
				// REST API — use 'rest_api' type so QuoteSettings shows the REST API layout
				dispatch({
					type: types.SET_DAYROSS_API_TYPE,
					payload: 'rest_api',
				})
			}
		}
	}, [connectionSettings, dispatch])

	useEffect(() => {
		if (connectionSettings) {
			dispatch({
				type: types.SET_CONNECTION_TYPE,
				payload: connectionSettings.connection_type || 'canada_shipment',
			})
		}
	}, [connectionSettings, dispatch])

	useEffect(() => {
		if (connectionSettings) {
			setRequiresDimensions(connectionSettings?.dimWeightBaseAccount ?? 0)
		}
	}, [connectionSettings])

	const onFinish = values => {
		values = {
			...values,
			testType,
			carrierId,
			installed_carrier_id: carrierId,
			api_version: apiVersion,
			dimWeightBaseAccount: requiresDimensions,
			// Preserve REST credentials even when saving SOAP settings so they aren't wiped
			//client_id: values.client_id ?? connectionSettings?.client_id,
			//client_secret: values.client_secret ?? connectionSettings?.client_secret,
		}

		// For legacy SOAP API, set sender_country_code based on api_type selection
		if (apiVersion === 'soap') {
			values.sender_country_code =
				values?.api_type === 'general_freight' ? 'US' : 'CA'
		} else {
			// REST API — default to CA (Day & Ross is a Canadian carrier)
			values.sender_country_code = 'CA'
		}

		dispatch(
			postData(
				values,
				'GET_CONNECTION_SETTINGS',
				'submit_connection_settings',
				token
			)
		)
	}

	if (!connectionSettings) return <Skeleton active />

	const cleanedInitialValues = {
		...connectionSettings,
		api_version: connectionSettings?.api_version || 'rest',
		api_type:
			(connectionSettings?.api_version || 'rest') === 'rest'
				? 'rest_api'
				: connectionSettings?.api_type || 'general_freight',
		connection_type: connectionSettings?.connection_type || 'canada_shipment',
	}

	const apiTypeSelect = (
		<Form.Item
			label='Which API Will You Connect To?'
			name='api_type'>
			<Select
				options={[
					{ label: 'REST API', value: 'rest_api' },
					{
						label: 'General Freight (SOAP API - no longer supported)',
						value: 'general_freight',
					},
					{ label: 'Sameday (SOAP API - no longer supported)', value: 'sameday' },
				]}
				onChange={opt => {
					if (opt === 'rest_api') {
						setApiVersion('rest')
						dispatch({
							type: types.SET_DAYROSS_API_TYPE,
							payload: 'rest_api',
						})
					} else {
						setApiVersion('soap')
						dispatch({
							type: types.SET_DAYROSS_API_TYPE,
							payload: opt,
						})
					}
				}}
			/>
		</Form.Item>
	)

	const apiConnectionTypeSelect = (
	<Form.Item
		label="Test Connection Mode"
		name='connection_type'
	>
		<Select
			options={[
				{ label: 'Shipments to Canada', value: 'canada_shipment' },
				{ label: 'Shipments to USA', value: 'usa_shipment' },
				{ label: 'Custom Destination', value: 'custom_destination' },
			]}
			onChange={(value) => {
				dispatch({
					type: types.SET_CONNECTION_TYPE,
					payload: value,
				})
			}}
		/>
	</Form.Item>
	)

	return (
		<Fragment>
			<div className={'note-bx'}>
				<strong>Note:</strong>{' '}
					<>
						You must have a shipping account with Day &amp; Ross to
						use this application. If you do not have an account, contact 
						Day &amp;
						Ross at <strong>866-329-7677</strong> or{' '}
						<a
							href='mailto:custservice@dayandrossinc.ca'
							target='_blank'
							rel='noreferrer'>
							custservice@dayandrossinc.ca
						</a>.
						Once you receive your account credentials, return to these connection settings.
					</>
			</div>
			<Form
				layout='vertical'
				name='connection_settings'
				className='connection-settings'
				size='large'
				initialValues={cleanedInitialValues}
				onFinish={onFinish}>

				{/* {apiVersion === 'rest' && (
					<div className={'note-bx'}>
						<strong>Notice:</strong> Day &amp; Ross REST API Test
						Connection will not work until{' '}
						<strong>March 7, 2026</strong>.
					</div>
				)} */}
				<Form.Item
					label='Nickname'
					name='nickname'
					required={true}
					rules={[
						{
							required: !testType,
							message: 'Nickname is required',
						},
					]}>
					<Input
						placeholder='e.g., Day & Ross'
						maxLength={50}
					/>
				</Form.Item>

				{/* SOAP: Which API first */}
				{apiVersion === 'soap' && apiTypeSelect}

				

				{/* REST: Which API after Nickname */}
				{apiVersion === 'rest' && apiTypeSelect}

				{/*{apiVersion === 'rest' && (
					<>
						<Form.Item
							label='Client ID'
							name='client_id'
							required={true}
							rules={[
								{
									required: testType && apiVersion === 'rest',
									message: 'Client ID is required',
								},
							]}>
							<Input
								placeholder='Client ID'
								maxLength={50}
							/>
						</Form.Item>
						<Form.Item
							label='Client Secret'
							name='client_secret'
							required={true}
							rules={[
								{
									required: testType && apiVersion === 'rest',
									message: 'Client Secret is required',
								},
							]}>
							<Input
								type='text'
								placeholder='Client Secret'
								maxLength={50}
							/>
						</Form.Item>
					</>
				)}*/}

				{/* SOAP: Bill to account number moved up */}
				{apiVersion === 'soap' && (
					<Form.Item
						label='Bill to account number'
						name='billing_account_number'
						required={true}
						rules={[
							{
								required: testType,
								message: 'Bill to account number is required',
							},
						]}>
						<Input
							placeholder='Bill to account number'
							maxLength={128}
						/>
					</Form.Item>
				)}

				{apiVersion === 'soap' && (
					<Form.Item
						label='Account Number for shipments to USA'
						name='account_number'>
						<Input
							placeholder='Account Number for shipments to USA'
							maxLength={50}
						/>
					</Form.Item>
				)}

				<Form.Item
					label='Email'
					name='email'
					required={true}
					rules={[
						{
							required: testType,
							message: 'Email is required',
						},
					]}>
					<Input
						// placeholder='Email'
						maxLength={254}
					/>
				</Form.Item>
				<Form.Item
					label='Password'
					name='password'
					required={true}
					rules={[
						{
							required: testType,
							message: 'Password is required',
						},
					]}>
					<Input
						type='text'
						// placeholder='Password'
						maxLength={128}
					/>
				</Form.Item>

				{/* Contact Person For Shipments / Phone Number fields removed: Day & Ross now
					receives Eniture's support contact (hardcoded server-side) instead of
					merchant-entered values on all requests, so these are no longer collected. */}

				{/* REST: Bill to account number at bottom */}
				{apiVersion === 'rest' && (
					<Form.Item
						label='Bill To Account Number'
						name='billing_account_number'
						required={true}
						rules={[
							{
								required: testType,
								message: 'Bill To Account Number is required',
							},
						]}>
						<Input
							// placeholder='Bill To Account Number'
							maxLength={128}
						/>
					</Form.Item>
				)}

				{apiVersion === 'rest' && (
					<Form.Item
						label='Account Number For Shipments To USA'
						name='account_number'>
						<Input
							// placeholder='Account Number For Shipments To USA'
							maxLength={50}
						/>
					</Form.Item>
				)}

				{apiVersion === 'rest' && (
					<>
						<div className='ant-form-item-label' style={{ paddingBottom: 8 }}>
							<label>Shipment Origin for Test Connection<span style={{ color: '#ff4d4f', marginLeft: 4 }}>*</span></label>
						</div>
						<Row gutter={16}>
							<Col span={12}>
								<Form.Item
									name='sender_address'
									validateTrigger={[]}
									rules={[{ validator: (_, v) => v && v.trim() ? Promise.resolve() : Promise.reject(new Error('Street Address is required')) }]}>
									<Input placeholder='e.g.123 Main St' maxLength={255} />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									name='sender_city'
									validateTrigger={[]}
									rules={[{ validator: (_, v) => v && v.trim() ? Promise.resolve() : Promise.reject(new Error('City is required')) }]}>
									<Input placeholder='e.g. Vancouver' maxLength={100} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={12}>
								<Form.Item
									name='sender_state'
									validateTrigger={[]}
									rules={[{ validator: (_, v) => v && v.trim() ? Promise.resolve() : Promise.reject(new Error('Province/State is required')) }]}>
									<Input placeholder='e.g. BC' maxLength={50} />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									name='sender_zip'
									validateTrigger={[]}
									rules={[{ validator: (_, v) => v && v.trim() ? Promise.resolve() : Promise.reject(new Error('Postal Code is required')) }]}>
									<Input placeholder='e.g. V5K0A1' maxLength={20} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={12}>
								<Form.Item
									name='sender_country'
									validateTrigger={[]}
									rules={[{ validator: (_, v) => v && v.trim() ? Promise.resolve() : Promise.reject(new Error('Country is required')) }]}>
									<Input placeholder='e.g. CA' maxLength={10} />
								</Form.Item>
							</Col>
						</Row>
					</>
				)}
				{apiVersion === 'rest' && (
					apiConnectionTypeSelect
				)}
				{apiVersion === 'rest' && connectionType === 'custom_destination' && (
					<>
					<div className='ant-form-item-label' style={{ paddingBottom: 8 }}>
						<label>
								Shipment Destination for Test Connection<span style={{ color: '#ff4d4f', marginLeft: 4 }}>*</span>
						</label>
					</div>
					<Form.Item
						// label='Receiver Name'
						name='destination_receiver_name'>
						<Input placeholder='e.g. John Smith' maxLength={100} />
					</Form.Item>
						
						<Row gutter={16}>
						<Col span={12}>
							<Form.Item
							name='destination_address'
							validateTrigger={[]}
							rules={[
								{
								validator: (_, v) =>
									v && v.trim()
									? Promise.resolve()
									: Promise.reject(new Error('Street Address is required')),
								},
							]}
							>
							<Input placeholder='e.g. 456 Market Street' maxLength={255} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
							name='destination_city'
							validateTrigger={[]}
							rules={[
								{
								validator: (_, v) =>
									v && v.trim()
									? Promise.resolve()
									: Promise.reject(new Error('City is required')),
								},
							]}
							>
							<Input placeholder='e.g. Toronto' maxLength={100} />
							</Form.Item>
						</Col>
						</Row>
						<Row gutter={16}>
						<Col span={12}>
							<Form.Item
							name='destination_state'
							validateTrigger={[]}
							rules={[
								{
								validator: (_, v) =>
									v && v.trim()
									? Promise.resolve()
									: Promise.reject(new Error('Province/State is required')),
								},
							]}
							>
							<Input placeholder='e.g. ON' maxLength={50} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
							name='destination_zip'
							validateTrigger={[]}
							rules={[
								{
								validator: (_, v) =>
									v && v.trim()
									? Promise.resolve()
									: Promise.reject(new Error('Postal Code is required')),
								},
							]}
							>
							<Input placeholder='e.g. M5V2T6' maxLength={20} />
							</Form.Item>
						</Col>
						</Row>
						<Row gutter={16}>
						<Col span={12}>
							<Form.Item
							name='destination_country'
							validateTrigger={[]}
							rules={[
								{
								validator: (_, v) =>
									v && v.trim()
									? Promise.resolve()
									: Promise.reject(new Error('Country is required')),
								},
							]}
							>
							<Input placeholder='e.g. CA' maxLength={10} />
							</Form.Item>
						</Col>
						</Row>
					</>
					)}

				<div>
					<a
						href='https://eniture.com/bigcommerce-day-ross-connection-instructions/'
						target='_blank'
						rel='noreferrer'>
						How to obtain your Day & Ross API credentials?
					</a>
				</div>

				<Row gutter={30} className='mb-1 mt-2'>
					<Col
						className='gutter-row mb-1'
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}>
						<label>My Day & Ross account:</label>
					</Col>
					<Col xl={24} lg={24} md={24} sm={24} xs={24} className={'mb-1'}>
						<Radio
							onChange={() => setRequiresDimensions(0)}
							checked={requiresDimensions === 0}>
							doesn't require dimensions to get quotes
						</Radio>
					</Col>
					<Col xl={24} lg={24} md={24} sm={24} xs={24}>
						<Radio
							onChange={() => setRequiresDimensions(1)}
							checked={requiresDimensions === 1}>
							requires dimensions to get quotes
						</Radio>
					</Col>
				</Row>

				<Form.Item style={{ textAlign: 'right', marginBottom: '0' }}>
					<Space>
						<Button
							type='primary'
							size='large'
							htmlType='submit'
							name='test'
							onClick={() => handleTypeChange(true)}>
							Test Connection
						</Button>
						<Button
							type='primary'
							size='large'
							htmlType='submit'
							name='save'
							onClick={() => handleTypeChange(false)}>
							Save Settings
						</Button>
					</Space>
				</Form.Item>
			</Form>
		</Fragment>
	)
}

export default ConnectionSettingsComponent
